import { Quiz } from "../../../data-types/Types";

export const topicQuizIdsByGrade = {
  "4": {
    "I. Earning Income": "yfUPIKYDK7Q7gPZhhwIW",
    "II. Spending": "w6Ky1miYyeDyqL2q2d2H",
    "III. Saving": "ood6qfCWAcwbyr6SCcQi",
    "IV. Investing": "FrBvtLW5pvFm9E6goBzi",
    "V. Managing Credit": "EUDCyCe7rOGgi9KkpWKt",
    "VI. Managing Risk": "5w9Pm74NlFSOewcu2xsj"
  },
  "8": {
    "I. Earning Income": "hFo5y7X3pli2iXOE7qqB",
    "II. Spending": "QARrHEfsOBTIzEw8Ishw",
    "III. Saving": "vD8j3IWPJ7WdYDMGryOe",
    "IV. Investing": "n48EFoQwWhUf39RDOGRo",
    "V. Managing Credit": "iTB9H61oiEiNTY07s6A3",
    "VI. Managing Risk": "SiXY5Rj4ic690lxzsLtN"
  },
  "12": {
    "I. Earning Income": "ZmQZtYyOu6zCmqKy0oNF",
    "II. Spending": "wflAiJqOFTA7IGSMU0BU",
    "III. Saving": "sshfwH3eNEcEGmblusDD",
    "IV. Investing": "T4Ki1Jj4hKFcwwgPtnyu",
    "V. Managing Credit": "KLlJ4vaBGlpzDKe1XRMt",
    "VI. Managing Risk": "oxZy6OAohlpwbRXByi9E"
  }
} as const;

export type TopicQuizIdsByGrade = typeof topicQuizIdsByGrade;
export type GradeKey = keyof TopicQuizIdsByGrade;
export type TopicKey = keyof TopicQuizIdsByGrade["12"];

export const getDefaultQuizId = (grade?: string, topic?: string) => {
  if (!grade || !topic) {
    return "";
  }
  const gradeMap = topicQuizIdsByGrade[grade as GradeKey];
  if (!gradeMap) {
    return "";
  }
  return gradeMap[topic as TopicKey] || "";
};

export const getTopics = () => Object.keys(topicQuizIdsByGrade["12"]);

export const findQuizName = (quizzes: Quiz[], quizId: string) =>
  quizzes.find((quiz) => quiz.id === quizId)?.name || "";
